<template>
  <div class="text-sm">
    <p class="mt-6"><b>2025.03.03</b> - Пробивание брони</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Исправлен баг, из-за которого Пробивание брони не имел эффекта</li>
      <li>
        <div>Мощность Пробивание брони уменьшена:</div>
        <div>
          <code>15 + Уровень*(Си/7 + Лв/10)</code> -->
          <code>10 + Уровень*(Си/12 + Лв/15)</code>
        </div>
      </li>
      <li>Обновлено принятие решений ИИ о том, когда использовать Пробивание брони.</li>
      <li>Исправлен баг расчёта модификаторов урона от affinity.</li>
      <li>
        ИИ выбора целей врагами теперь учитывает стойки и affinity при расчёте наименьшего эффективного здоровья, а не только броню.
      </li>
    </ul>
  </div>
</template>
